// CellNameContent.jsx
import React, { useRef, useEffect } from "react";
import { ListSummaryDimensionInput } from "../../style";
import { UncontrolledTooltip } from "reactstrap";
import Cell from "../Cell";
import { isInternalAccess } from "../../../common/service";
import { isMobileOnly } from "react-device-detect";

const NameCell = ({
  type,
  rowId,
  name,
  isFiller,
  sku,
  tempId,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  invalid,
  errorMessage,
  tableManager,
  userLabel,
  sectionId,
  className = "flex-grow-0 flex-shrink-0",
  copyPasteTooltip = {},
  pasteOverrides,
  handleTabNavigation,
  onContextMenu,
}) => {
  const inputRef = useRef();

  useEffect(() => {
    if (
      tableManager.isActive(type, rowId, "name") &&
      inputRef.current &&
      typeof inputRef.current.setSelectionRange === "function"
    ) {
      const val = inputRef.current.value ?? "";
      inputRef.current.focus();
      inputRef.current.setSelectionRange(val.length, val.length);
    }
  }, [tableManager.isActive(type, rowId, "name")]);

  return (
    <Cell
      rowType={type}
      rowId={rowId}
      column="name"
      status="focus"
      inline={true}
      className={className}
      customStyles={{
        width: isMobileOnly ? "30%" : "150px",
        outline:
          value == "" &&
          (tableManager.getStatus(type, rowId, "name") == "idle" ||
            tableManager.getStatus(type, rowId, "name") == "focus")
            ? "2px solid red"
            : tableManager.getStatus(type, rowId, "name") == "focus"
            ? "2px solid #2C92E6"
            : "",
      }}
      tableManager={tableManager}
      isTemp={tempId}
      errorMessage={errorMessage}
      isFillerRow={isFiller}
      sectionId={sectionId}
      copyPasteTooltip={copyPasteTooltip}
      onContextMenu={onContextMenu}
    >
      {isFiller ||
      tableManager.isFocused(type, rowId, "name") ||
      tableManager.getStatus(type, rowId, "name") == "idle" ? (
        <div className="text-start p-1" id={`${type}_name_${rowId}`}>
          {pasteOverrides ?? value ?? name}
        </div>
      ) : (
        <ListSummaryDimensionInput
          innerRef={inputRef}
          type="text"
          autoComplete="off"
          className="text-start dimension"
          value={value}
          onChange={onChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
              setTimeout(() => {
                if (tableManager.isCurrentlyActive()) {
                  tableManager.set(rowId, type, "name", "focus");
                }
              }, 50);
            }
            if (e.key === "Tab") {
              e.preventDefault();
              e.target.blur();
              handleTabNavigation;
            }
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          id={`${type}_name_${rowId}`}
          invalid={invalid}
          autoFocus={tableManager.isActive(type, rowId, "name")}
        />
      )}

      {document.getElementById(`${type}_name_${rowId}`) && (
        <UncontrolledTooltip target={`${type}_name_${rowId}`} placement="top">
          {sku && <div className="mb-2">SKU: {sku}</div>}
          {isInternalAccess() && <div>Id: #{rowId}</div>}
        </UncontrolledTooltip>
      )}
    </Cell>
  );
};

export default NameCell;
